import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, vShow as _vShow, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/camera.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-c71ca0ec")

_pushScopeId("data-v-c71ca0ec")
const _hoisted_1 = { class: "container promo-container" }
const _hoisted_2 = { class: "shape-title" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "several-section" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "default-title fs-16" }
const _hoisted_10 = { class: "default-text" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = {
  key: 0,
  class: "d-flex justify-content-end"
}
const _hoisted_15 = { class: "text-end" }
const _hoisted_16 = {
  key: 0,
  class: "status-green"
}
const _hoisted_17 = {
  key: 1,
  class: "status-red"
}
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "default-title" }
const _hoisted_21 = { class: "default-text" }
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "default-title" }
const _hoisted_24 = { class: "default-text" }
const _hoisted_25 = { class: "position-relative" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "default-title" }
const _hoisted_29 = { class: "default-text" }
const _hoisted_30 = { class: "position-relative" }
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "default-title" }
const _hoisted_33 = { class: "default-text" }
const _hoisted_34 = { class: "position-relative" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-md-12" }
const _hoisted_37 = { class: "image-container" }
const _hoisted_38 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_39 = { class: "text-center" }
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "footer-space" }, null, -1)
const _hoisted_41 = { class: "product-edit-container" }
const _hoisted_42 = { class: "row d-flex justify-content-between justify-content-lg-center" }
const _hoisted_43 = { class: "col-4 col-lg-2 order-modify-container" }
const _hoisted_44 = { class: "col-4 col-lg-2 order-modify-container" }
const _hoisted_45 = {
  type: "submit",
  class: "order-modify-button-wrapper btn-green",
  form: "promoForm"
}
const _hoisted_46 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-save fs-20" }, null, -1)
const _hoisted_47 = { class: "my-1" }
const _hoisted_48 = /*#__PURE__*/_createVNode("i", { class: "arrow up" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Multiselect = _resolveComponent("Multiselect")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('title.promoCategories')), 1)
    ]),
    _createVNode("form", {
      novalidate: "",
      id: "promoForm",
      onSubmit: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.submitForm($event)), ["prevent"]))
    }, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('label.promoPosition')) + ":", 1),
                _createVNode("div", _hoisted_10, [
                  (_ctx.promoCategory.order)
                    ? (_openBlock(), _createBlock("span", _hoisted_11, _toDisplayString(_ctx.promoCategory.order), 1))
                    : (_openBlock(), _createBlock("span", _hoisted_12, _toDisplayString(_ctx.promoCounter + 1), 1))
                ])
              ]),
              _createVNode("div", _hoisted_13, [
                (_ctx.promoCategory.order)
                  ? (_openBlock(), _createBlock("div", _hoisted_14, [
                      _createVNode("div", _hoisted_15, [
                        _withDirectives(_createVNode("input", {
                          type: "checkbox",
                          class: "toggle",
                          checked: _ctx.promoCategory.active,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.promoCategory.active = $event))
                        }, null, 8, ["checked"]), [
                          [_vModelCheckbox, _ctx.promoCategory.active]
                        ]),
                        _createVNode("div", null, [
                          (_ctx.promoCategory.active)
                            ? (_openBlock(), _createBlock("span", _hoisted_16, "ACTIVE"))
                            : (_openBlock(), _createBlock("span", _hoisted_17, "NOT ACTIVE"))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_18, [
              _createVNode("div", _hoisted_19, [
                _createVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('promo.categoryName')) + ":", 1),
                _createVNode("div", _hoisted_21, [
                  _withDirectives(_createVNode("input", {
                    required: "",
                    type: "text",
                    class: "bookit-input form-control",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.promoCategory.name = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.promoCategory.name]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_22, [
                _createVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('title.region')) + ":", 1),
                _createVNode("div", _hoisted_24, [
                  _createVNode("div", _hoisted_25, [
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.promotedCategoryRegions,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.promotedCategoryRegions = $event)),
                      valueProp: "id",
                      label: "name",
                      options: _ctx.regions,
                      "close-on-select": true,
                      searchable: true,
                      mode: "multiple",
                      trackBy: "name",
                      required: "",
                      class: { 'form-controll-multiselect': _ctx.promotedCategoryRegions.length === 0 }
                    }, null, 8, ["modelValue", "options", "class"]),
                    (_ctx.promoCategory.regionId)
                      ? (_openBlock(), _createBlock("i", {
                          key: 0,
                          class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.promoCategory.regionId = null))
                        }))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_26, [
              _createVNode("div", _hoisted_27, [
                _createVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('promo.productType')) + ":", 1),
                _createVNode("div", _hoisted_29, [
                  _createVNode("div", _hoisted_30, [
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.promoCategory.productTypeId,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.promoCategory.productTypeId = $event)),
                      valueProp: "id",
                      label: "name",
                      options: _ctx.productTypes,
                      "close-on-select": true,
                      required: "",
                      class: { 'form-controll-multiselect': !_ctx.promoCategory.productTypeId }
                    }, null, 8, ["modelValue", "options", "class"]),
                    (_ctx.promoCategory.productTypeId)
                      ? (_openBlock(), _createBlock("i", {
                          key: 0,
                          class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.promoCategory.productTypeId = null))
                        }))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_31, [
                _createVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('title.tags')) + ":", 1),
                _createVNode("div", _hoisted_33, [
                  _createVNode("div", _hoisted_34, [
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.promoCategorySubTags,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.promoCategorySubTags = $event)),
                      valueProp: "id",
                      label: "name",
                      options: _ctx.subTags,
                      "close-on-select": true,
                      searchable: true,
                      mode: "multiple",
                      trackBy: "name"
                    }, null, 8, ["modelValue", "options"])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_35, [
              _createVNode("div", _hoisted_36, [
                _createVNode("div", _hoisted_37, [
                  _createVNode("div", {
                    class: ["flex-grow-1 d-flex", { 'justify-content-center': !_ctx.promoImage && !_ctx.promoCategory.imagePath }]
                  }, [
                    (_ctx.promoImage || _ctx.promoCategory.imagePath)
                      ? (_openBlock(), _createBlock("div", _hoisted_38, [
                          _createVNode("img", {
                            class: "promo-image",
                            height: "108",
                            src: _ctx.promoImage || _ctx.promoCategory.imageToShow,
                            alt: ""
                          }, null, 8, ["src"]),
                          _createVNode("i", {
                            class: "icon-f icon-delete-cross fs-12 px-2 py-1 align-self-start",
                            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.clearImage && _ctx.clearImage(...args)))
                          }),
                          _createVNode("i", {
                            class: "icon-f icon-pencil-edit fs-12 py-1 align-self-start",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$refs.file.click()))
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _withDirectives(_createVNode("label", _hoisted_39, [
                      _createVNode("input", {
                        ref: "file",
                        type: "file",
                        name: "",
                        id: "image-upload-input",
                        style: {"display":"none"},
                        onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.uploadingImageValidation && _ctx.uploadingImageValidation(...args))),
                        accept: "image/*"
                      }, null, 544),
                      _createVNode("img", {
                        class: ["pointer", { 'png-red': _ctx.validated && !_ctx.promoCategory.image }],
                        src: _imports_0
                      }, null, 2),
                      _createVNode("div", {
                        class: ["text-link py-1", { 'color-red': _ctx.validated && (!_ctx.promoCategory.image && !_ctx.promoCategory.imagePath) }]
                      }, _toDisplayString(_ctx.$t('link.upload-image')), 3)
                    ], 512), [
                      [_vShow, !_ctx.promoImage && !_ctx.promoCategory.imagePath]
                    ])
                  ], 2)
                ])
              ])
            ])
          ])
        ])
      ])
    ], 32),
    _hoisted_40,
    _createVNode("div", _hoisted_41, [
      _createVNode("div", _hoisted_42, [
        _createVNode("div", _hoisted_43, [
          _createVNode("button", {
            type: "button",
            class: "order-modify-button-wrapper dark-circle-button",
            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
          }, _toDisplayString(_ctx.$t('button.cancel')), 1)
        ]),
        _createVNode("div", _hoisted_44, [
          _createVNode("button", _hoisted_45, [
            _hoisted_46,
            _createVNode("div", _hoisted_47, _toDisplayString(_ctx.$t('button.save')), 1)
          ])
        ])
      ]),
      (_ctx.promoCategory.order)
        ? (_openBlock(), _createBlock("button", {
            key: 0,
            class: "arrow-button",
            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.scrollToTop && _ctx.scrollToTop(...args))),
            type: "button"
          }, [
            _hoisted_48
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})